var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/__render.tsx
import React from "react";
import { createMapStateToProps, mergeProps } from "@vf-djr/utilities";
var conditionalRenderingPlugin = ({ __render }, Element, { selectors = {}, ReactReduxContext, connect } = {}) => {
  if (!connect) {
    console.error("Missing the 'connect' initialisation property for the Conditional Render plugin");
    return Element;
  }
  const Component = Element;
  const Suspend = (_a) => {
    var _b = _a, { dj$render } = _b, props = __objRest(_b, ["dj$render"]);
    return dj$render ? /* @__PURE__ */ React.createElement(Component, __spreadValues({}, props)) : /* @__PURE__ */ React.createElement(React.Fragment, null);
  };
  const mapStateToProps = createMapStateToProps(selectors)({
    dj$render: __render
  });
  return connect(mapStateToProps, {}, mergeProps, {
    context: ReactReduxContext
  })(Suspend);
};
var render_default = conditionalRenderingPlugin;

// src/index.ts
var src_default = render_default;
export {
  src_default as default
};
